module.exports = __webpack_public_path__ + "img/phone2.4aabcdae.png";